import {Currency} from '@store/common/organisation.enums';
import {UnitOfMeasure} from '@store/settings/serviceKinds';

export interface ManagePrice extends Partial<Price> {
  wasUpdated?: boolean;
  unitCost?: number;
  unitPrice?: number;
}

export interface Price {
  id: number;
  unitCostInCents: number;
  unitPriceInCents: number;
  currency: Currency;
  unit: UnitOfMeasure;
  minQuantity: number;
  maxQuantity: number;
  validFromDate?: Date;
}

export namespace Price {
  export const toManagePrice = (price: Price): ManagePrice => ({
    ...price,
    unitCost: price.unitCostInCents / 100,
    unitPrice: price.unitPriceInCents / 100,
  });
}
